"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerOrderPreAvailableInfoApi = customerOrderPreAvailableInfoApi;
exports.customerOrderPreConfirmMakeApi = customerOrderPreConfirmMakeApi;
exports.customerOrderPreCreateApi = customerOrderPreCreateApi;
exports.customerOrderPreDeleteApi = customerOrderPreDeleteApi;
exports.customerOrderPreDetailApi = customerOrderPreDetailApi;
exports.customerOrderPreDownloadApi = customerOrderPreDownloadApi;
exports.customerOrderPreDownloadTaskApi = customerOrderPreDownloadTaskApi;
exports.customerOrderPreFuCardListApi = customerOrderPreFuCardListApi;
exports.customerOrderPreListApi = customerOrderPreListApi;
exports.customerOrderPreResetDataApi = customerOrderPreResetDataApi;
exports.customerOrderPreUpdateApi = customerOrderPreUpdateApi;
exports.customerProgramListApi = customerProgramListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function customerProgramListApi(params) {
  return (0, _request.default)({
    url: '/admin/companyapp/autoList',
    method: 'GET',
    params: params
  });
}
function customerOrderPreFuCardListApi(params) {
  return (0, _request.default)({
    url: '/admin/fudou/fucard/select',
    method: 'GET',
    params: params
  });
}
function customerOrderPreListApi(params) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/list',
    method: 'GET',
    params: params
  });
}
function customerOrderPreAvailableInfoApi(params) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/available/info',
    method: 'GET',
    params: params
  });
}
function customerOrderPreDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/detail',
    method: 'GET',
    params: params
  });
}
function customerOrderPreResetDataApi(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/resetData',
    method: 'POST',
    data: data
  });
}
function customerOrderPreDownloadApi(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/download',
    method: 'POST',
    data: data
  });
}
function customerOrderPreDownloadTaskApi(taskId) {
  return (0, _request.default)({
    url: "/admin/order/customer/pre/async/task/".concat(taskId),
    method: 'GET'
  });
}
function customerOrderPreCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/create',
    method: 'POST',
    data: data
  });
}
function customerOrderPreConfirmMakeApi(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/confirmMake',
    method: 'POST',
    data: data
  });
}
function customerOrderPreUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/update',
    method: 'POST',
    data: data
  });
}
function customerOrderPreDeleteApi(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/pre/delete',
    method: 'POST',
    data: data
  });
}